<template>
  <div id="applications_list">
    <h2>Status</h2>
    <table class="table">
      <thead>
        <tr>
          <th>Application</th>
          <th>Submitted At</th>
          <th v-if="showStatueses">Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="app in applications" :key="app.id">
          <td>{{ app.housingPoolName }}</td>
          <td>{{ app.displayDate }}</td>
          <td v-if="showStatueses">
            <template v-if="app.showStatus">
              {{ app.displayState }}
            </template>
          </td>
          <td class="hidden-xs">
            <a v-if="app.editable" :href="app.editUrl">Edit</a>
          </td>
        </tr>
        <tr v-show="applications.length === 0">
          <td colspan="4" style="text-align: center">
            You have not yet submitted any applications.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { Application } from "../types";

defineOptions({
  name: "StatusList",
});

type Props = {
  applications?: Application[];
};

const props = withDefaults(defineProps<Props>(), {
  applications: () => [],
});

const showStatueses = computed(() =>
  props.applications.some((x) => x.showStatus),
);
</script>
